import React from 'react';
import styled from 'styled-components';

export default ({ src, ...other }) => (
  <ImageContainer {...other}>
    <ProductImage src={src} />
  </ImageContainer>
);

export const ImageContainer = styled.div`
  width: 55%;
  padding-top: 31.66%;
  position: relative;
`;

export const ProductImage = styled.div`
  background-image: url(${props => props.src});
  background-position: center center;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
